export default __webpack_public_path__ + "static/media/topics.124b6230.png";